import React from 'react'

import FeatureCheck from 'components/FeatureCheck'
import Grid from 'components/Grid'

import classes from './FeaturesOverview.module.scss'

export const isChecked = (list, ...slugs) => !!list.find(item => slugs.includes(item) || slugs.includes(item.slug))

const FeaturesOverview = ({ listing }) => {
  return (
    <Grid className="Features" spacing={4} container>
      <Grid item xs={12} sm={6} lg={3}>
        <p className={classes.featureTitle}>Typical customers</p>
        <div className={classes.featureList}>
          <FeatureCheck checked={isChecked(listing.typical_customers, 'freelancers')}>Freelancers</FeatureCheck>
          <FeatureCheck checked={isChecked(listing.typical_customers, 'small-business')}>Small businesses</FeatureCheck>
          <FeatureCheck checked={isChecked(listing.typical_customers, 'mid-size-business')}>
            Mid size businesses
          </FeatureCheck>
          <FeatureCheck checked={isChecked(listing.typical_customers, 'large-enterprises')}>
            Large enterprises
          </FeatureCheck>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <p className={classes.featureTitle}>Platforms supported</p>
        <div className={classes.featureList}>
          <FeatureCheck checked={isChecked(listing.platforms, 'web-based')}>Web</FeatureCheck>
          <FeatureCheck checked={isChecked(listing.platforms, 'android')}>Android</FeatureCheck>
          <FeatureCheck checked={isChecked(listing.platforms, 'ipad', 'iphone')}>iPhone/iPad</FeatureCheck>
        </div>
      </Grid>
      {listing.support_options.length > 0 && (
        <Grid item xs={12} sm={6} lg={3}>
          <p className={classes.featureTitle}>Support options</p>
          <div className={classes.featureList}>
            {listing.support_options.map(option => (
              <FeatureCheck key={option} checked>
                {option}
              </FeatureCheck>
            ))}
          </div>
        </Grid>
      )}
      {listing.training_options.length > 0 && (
        <Grid item xs={12} sm={6} lg={3}>
          <p className={classes.featureTitle}>Training options</p>
          <div className={classes.featureList}>
            {listing.training_options.map(option => (
              <FeatureCheck key={option} checked>
                {option}
              </FeatureCheck>
            ))}
          </div>
        </Grid>
      )}
    </Grid>
  )
}

export default FeaturesOverview
